angular.
module("dx.webapp.examDuration", [
	"dx.webapp.exam",

	"dx.ui.utils",
	"dx.ui.components.localize",
]);
